import { SaveFormService } from './../../../services/save-form.service';
import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CategoriesService } from '../../../services/categories.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ModalBase } from '../modal-base';
import { ConfigService } from '../../../services/config.service';
import { CookieService } from 'ngx-cookie-service';
import { Category } from '../../../models/questions';
import { EnumDescription } from '../../../helpers/enum-description.helper';
import { QuestionCategoryType } from '../../../models/questions/question-category-type.enum';
import { ProcessTypeFeatureFlags } from '../../../models/process-type-feature-flags.enum';

@Component({
  selector: 'app-modal-edit',
  templateUrl: './modal-edit.component.html',
  styleUrls: ['./modal-edit.component.scss'],
})
export class ModalEditComponent implements OnInit {
  @Input() modalData: Category;

  modalForm: FormGroup;
  modalRef: BsModalRef;
  propName = 'name';
  propertiesArray: Array<string> = [];
  baseModal: ModalBase;
  checkBoxesControls: Array<FormControl>;
  isOnSaving: boolean = false;
  isDisabled = false;
  questionCategoryType = QuestionCategoryType;
  feature = ProcessTypeFeatureFlags;

  private adminLanguageNameKey: string;

  constructor(
    private modalFormBuilder: FormBuilder,
    private modalService: BsModalService,
    private categoriesServices: CategoriesService,
    private appData: ConfigService,
    private saveFormService: SaveFormService,
    private cookieService: CookieService
  ) {}

  openModal(template: TemplateRef<any>) {
    if (this.isDisabled) {
      return;
    }
    this.isDisabled = true;
    setTimeout(() => (this.isDisabled = false), 500);
    this.getLocalizedCategory(template);
  }

  ngOnInit() {
    this.adminLanguageNameKey = this.appData.configData.cookieAdminLanguageKey;
    this.modalService.onHide.subscribe(() => {
      this.isOnSaving = false;
    });
  }

  getLocalizedCategory(template: TemplateRef<any>) {
    this.categoriesServices.getOne(this.modalData.id).subscribe((x) => {
      this.baseModal = new ModalBase(
        this.categoriesServices,
        this.modalData,
        this.appData
      );
      this.modalData.questionCategoryTypes = x.questionCategoryTypes;
      this.modalForm = this.modalFormBuilder.group({
        checkboxes: this.baseModal.buildCheckboxControls(this.modalFormBuilder),
      });
      this.saveFormService.addAllLocalizedNameToFormGroup(
        this.modalForm,
        this.propName,
        x.localizedNames
      );
      this.propertiesArray = this.saveFormService.mapFormGroupControlToPropArray(
        this.modalForm,
        this.propName
      );
      this.checkBoxesControls = this.baseModal.getCheckBoxes(this.modalForm);
      this.modalRef = this.modalService.show(template);
    });
  }

  getCheckboxLabel(indexValue: number) {
    const enumValue = this.getQuestionCategoryTypeByIndex(indexValue);
    return EnumDescription.GetDescription(QuestionCategoryType, enumValue);
  }

  getQuestionCategoryTypeByIndex(indexValue: number) {
    return Math.pow(2, indexValue);
  }

  onSave() {
    if (this.isOnSaving) {
      return;
    }
    this.isOnSaving = true;
    this.modalData.localizedNames = this.baseModal.mapFormvalueToCategory(
      this.modalForm.value,
      this.propName
    );
    const langName = this.cookieService.get(this.adminLanguageNameKey);
    this.modalData.name = this.modalData.localizedNames.find(
      (x) => x.locale === langName
    ).name;
    this.baseModal.mapCheckboxesValues(this.modalForm);
    this.baseModal.saveOnEdit(this.modalData, this.modalRef);
  }
}
